import {ProductionLinks} from '../app/src/constant/ProductionLinks';

export const environment = {
  production: true,
  links: ProductionLinks
};
